export enum DocumentTemplateRoles {
  VIEWER = 'roles.documentTemplateViewer',
  MANAGER = 'roles.documentTemplateManager',
}
